import { Box, SxProps } from "@mui/material";
import { FC } from "react";
import DARSLogoImage from "../../assets/icons/DARS.svg";


const style: SxProps = {
    bgcolor: "#ffffff",
    maxWidth: 'md'
  };

const DARSLogo: FC<{}> = () => {
  return (
    <Box
      component="img"
      sx={{ ...style }}
      alt="DARS Logo"
      src={DARSLogoImage}
    />
  );
};

export default DARSLogo;
//DARSLogo.whyDidYouRender = true;
